import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {


	clickCounter: number = 0;
	activacion = false;
	name: string = '';

  constructor() { }

  ngOnInit() {
  }

  countClick() {
  	this.clickCounter += 1;
  	if(this.clickCounter > 4){
  		this.activacion = true;
  		console.log("la activacion es " + this.activacion)
  	}
  }

  setClasses() {
  	let myClasses = {
  		active: this.clickCounter > 4, 
  		notactive: this.clickCounter <= 4,
  	}
  	return myClasses
  }

}
